import React from 'react';
import {
    Select,
    TextField
} from '@shopify/polaris';

export function TagTemplateFormElement(props) {

    function onTemplateValueChange(settingName, value) {
        var newSettings = JSON.parse(JSON.stringify(props.templateSettings));
        newSettings[settingName] = value;
        props.onChange(newSettings);
    }

    return (
        <React.Fragment>
            <TextField
                value={props.templateSettings.prefix}
                error={props.templateSettingsErrors["prefix"]}
                label="Prefix"
                placeholder="(Optional) Leave blank if you do not want any prefixes"
                onChange={(newValue) => onTemplateValueChange("prefix", newValue)}
                helpText={
                    <span>
                        Prepend each tag with the prefix value.
                    </span>
                }
            />
            <Select
                label="Casing Transformation"
                options={[
                    { label: 'None - use original value', value: 'KeepOriginal' },
                    { label: 'Upper case - uppercase for all letters', value: 'UpperCase' },
                    { label: 'Lower case - lower case for all letters', value: 'LowerCase' },
                    { label: 'Sentence case - lower case for all letters', value: 'SentenceCase' },
                ]}
                onChange={(newValue) => onTemplateValueChange("casingTransformation", newValue)}
                value={props.templateSettings.casingTransformation}
                error={props.templateSettingsErrors["casingTransformation"]}
                helpText={
                    <span>
                        Keep using the original casing or transform it to upper case, lower case or sentence case.
                    </span>
                }
            />
            <Select
                label="Spacing Transformation"
                options={[
                    { label: 'Keep spaces', value: 'KeepSpaces' },
                    { label: 'Use underscores - replace spaces with underscore', value: 'ReplaceWithUnderscores' },
                    { label: 'Use hyphens - replace spaces with hypens', value: 'ReplaceWithHyphens' },
                ]}
                onChange={(newValue) => onTemplateValueChange("spacesTransformation", newValue)}
                value={props.templateSettings.spacesTransformation}
                error={props.templateSettingsErrors["spacesTransformation"]}
                helpText={
                    <span>
                        Replace spaces with underscores or keep spaces.
                    </span>
                }
            />
        </React.Fragment>
    );
}